import React from "react";
import GenericRoutesList from "components/Routes/GenericRoutesList";
import { ROUTE_CONFIGS } from "config/routeConfigs";

const RecentRoutes = () => {
  const config = ROUTE_CONFIGS.recent;
  return (
    <GenericRoutesList
      routeType="recent"
      columnsConfig={config.columns}
      mapPath={config.mapPath}
      features={config.features}
      selector={config.selector}
      paginationSelector={config.paginationSelector}
      loadAction={config.loadAction}
    />
  );
};

export default RecentRoutes;